//定义全局指令处理菜单el-sub-menu控制台报错
function removeAriaHidden(element) {
  // 使用递归函数移除当前元素及其所有子元素的 aria-hidden 属性
  function traverseAndRemoveAriaHidden(el) {
    if (el.hasAttribute('aria-hidden')) {
      el.removeAttribute('aria-hidden');
    }

    // 遍历所有子元素
    const children = el.children;
    for (let i = 0; i < children.length; i++) {
      traverseAndRemoveAriaHidden(children[i]);
    }
  }

  // 调用递归函数处理传入的元素
  traverseAndRemoveAriaHidden(element);
}
export default {
  beforeMount(el) {
    removeAriaHidden(el); // 初次处理
    // 立即移除 aria-hidden 属性
  },
  updated(el) {
    removeAriaHidden(el); // DOM 更新时处理
  },
}